import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        displayMode: {
            type: String,
            required: false
        },
        yMax: {
            type: Number,
            default: 0
        }
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const project = this._chart.config.data.projects[chart_element._index]
                this.$emit("click", project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    callbacks: {
                        title: (tooltipItems, data) => {
                            const project = data.projects.find(project => project.id === data.datasets[0].project_ids[tooltipItems[0].index]) // data.projects[tooltipItems[0].index]
                            let title = project.nickname || project.name
                            if(project.number) title = `${project.number} ${title}`
                            return title
                        },
                        label: (tooltipItem, data) => {
                            const project = data.projects.find(project => project.id === data.datasets[0].project_ids[tooltipItem.index]) // data.projects[tooltipItem.index]
                            const value = numeral(tooltipItem.yLabel)
                            let label = ""
                            let addl_value

                            if(this.displayMode === "relative") {
                                if(tooltipItem.datasetIndex === 1) addl_value = Math.abs(project.remaining)
                                else addl_value = project.computed_fee
                                if(project.remaining < 0) {
                                    if(tooltipItem.datasetIndex === 1) label = "Over Budget: " + value.format("0,0") + "%"
                                    else label = "Budget: " + value.format("0,0") + "%"
                                } else label = data.datasets[tooltipItem.datasetIndex].label + ": " + value.format("0,0") + "%"
                                return label + " ($" + numeral(addl_value).format("0,0") + ")"
                            }

                            addl_value = project.computed_fee ? (value.value() / project.computed_fee) * 100 : 0
                            if((tooltipItem.datasetIndex === 1) && (project.remaining < 0)) label = "Over Budget: $" + value.format("0,0")
                            else label = data.datasets[tooltipItem.datasetIndex].label + ": $" + value.format("0,0") + " / $" + numeral(project.computed_fee).format("0,0")

                            return label + " (" + numeral(addl_value).format("0,0") + "%)"
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                if(this.displayMode === "relative") return numeral(value).format("0,0") + "%"
                                return "$" + numeral(value).format("0,0")
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
